const CACHE_KEY = "featureToggle:SpondFrontendOneWebShell";
const HTML_CLASS = "oneweb";

export function applyCachedOneWebShell(): void {
    try {
        document.documentElement.classList.toggle(HTML_CLASS, window.localStorage.getItem(CACHE_KEY) === "true");
    } catch (e) {
        // Storage is blocked, so the page keeps the classic look.
    }
}
